export default "__VITE_ASSET__DKZIBC8Y__"